class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Load on mouseover or when clicking button
    this.addEventListener("mouseenter", () => this._loadData());
    this.addEventListener("click", (e) => {
      // const link = e.target.closest("a");

      // if (link && "page" in this.dataset && this.dataset.page !== "1") {
      //   e.preventDefault();
      //   const newUrl = new URL(window.location);
      //   newUrl.searchParams.set("page", this.dataset.page);
      //   window.history.replaceState("", "", newUrl);
      //   window.location = link.href;
      //   return;
      // }

      const quickViewTrigger = e.target.closest("[data-quickview-trigger]");

      if (!quickViewTrigger) return;

      this._loadData().then((nodes) => {
        quickViewTrigger.dispatchEvent(
          new CustomEvent("markup-modal:open", {
            bubbles: true,
            detail: { nodes: [...nodes], target: "quickview-modal" },
          }),
        );
      });
    });
  }

  disconnectedCallback() {}

  // _changeContent(productId) {
  //   this._loadData().then((data) => {
  //     const productData = data.find(({ product_id }) => product_id === productId);

  //     if (!productData) {
  //       console.warn(`No product card data found for ${productId}`);
  //       return;
  //     }

  //     const html = new DOMParser().parseFromString(
  //       productData.markup,
  //       "text/html",
  //     );

  //     const newProductCardMarkup = html.querySelector("product-card");

  //     morph(this, newProductCardMarkup);
  //   });
  // }

  _loadData() {
    if (this.loadingData) return this.loadingData;

    const url = new URL(`${window.location.origin}${this.productUrl}`);

    url.searchParams.set("view", "quickview");

    this.loadingData = fetch(url)
      .then((res) => res.text())
      .then((markup) => {
        const html = new DOMParser().parseFromString(markup, "text/html");

        const mainContent = document
          .createRange()
          .createContextualFragment(
            html.querySelector("#MainContent").innerHTML,
          );

        return mainContent.children;
      });

    return this.loadingData;
  }

  get productUrl() {
    return this.getAttribute("product-url");
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
